import { useTranslation } from "react-i18next";

// Shared by all four matchday sliders and by their editor previews, so it lives
// here rather than in one of the templates' Index.jsx — importing it from there
// makes the overlay and the template import each other in a cycle.
// The same answer as getOneLetterResult, but handed `t` instead of reaching
// for it itself.
//
// getOneLetterResult calls useTranslation() in its body, which makes it a hook.
// That is survivable where the caller maps it over a list whose length never
// changes, but not where the list arrives after the first render: the editor
// mounts its preview with an empty templateData and fills it in a moment later,
// so the run goes 0 circles -> 5, the component's hook count changes between
// renders, and React refuses to continue. Callers that map over feed data want
// this version and their own component-level `t`.
export const oneLetterResult = (t, data, teamId, selectedLang) => {
  let side = 'home';
  if (data.awayId === teamId) {
    side = 'away';
  }

  if (data?.scoreHome > data?.scoreAway) {
    return side === "home"
      ? t("W", { keyPrefix: "table", lng: selectedLang })
      : t("L", { keyPrefix: "table", lng: selectedLang });
  }

  if (data?.scoreHome < data?.scoreAway) {
    return side === "home"
      ? t("L", { keyPrefix: "table", lng: selectedLang })
      : t("W", { keyPrefix: "table", lng: selectedLang });
  }

  if (data?.scoreHome === data?.scoreAway) {
    return t("D", { keyPrefix: "table", lng: selectedLang });
  }

  return "-";
};

export const getOneLetterResult = (data, teamId, selectedLang) => {
  // calculate side
  let side = 'home';
  if (data.awayId === teamId) {
    side = 'away';
  }
  const { t } = useTranslation();
  if (data?.scoreHome > data?.scoreAway) {
    if (side === "home") {
      return t("W", { keyPrefix: "table", lng: selectedLang });
    } else {
      return t("L", { keyPrefix: "table", lng: selectedLang });
    }
  }

  if (data?.scoreHome < data?.scoreAway) {
    if (side === "home") {
      return t("L", { keyPrefix: "table", lng: selectedLang });
    } else {
      return t("W", { keyPrefix: "table", lng: selectedLang });
    }
  }

  if (data?.scoreHome === data?.scoreAway) {
    return t("D", { keyPrefix: "table", lng: selectedLang });
  }

  return "-";
};
